import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'
import { InstructorReportTopGame } from '../../../../contexts/ReportsContextHelper'
import classNames from 'classnames'
import { getIcon } from '../../../../common/components/icons/utils'
import { Tooltip } from '../../../../common/components/tooltip/Tooltip'

type ReportingGameCardProps = {
  game: InstructorReportTopGame
  topPlayedPosition: number
}

export const ReportingGameCard: React.FC<ReportingGameCardProps> = ({ game, topPlayedPosition }) => {
  const { t } = useTranslation()
  const { thumbnailUrl, gameName, modifiedAt, playerInfo } = game

  const handleOpenGame = useCallback(() => {
    window.open(`/game-editor/${game.id}`, '_blank')
  }, [game.id])

  return (
    <div className={styles.reportingGameCardContainer} key={topPlayedPosition}>
      <div className={classNames(styles.top, styles.reportingGameTop)} onClick={handleOpenGame}>
        <img crossOrigin='anonymous' src={'https://seppo-proxy.herokuapp.com/' + thumbnailUrl} alt='' />
        {topPlayedPosition > 0 && (
          <div
            className={classNames(
              styles.topPlayedPositionCircle,
              styles['topPlayedPositionCircle' + topPlayedPosition],
            )}
          >
            <h1>{topPlayedPosition}</h1>
          </div>
        )}
      </div>
      <div className={styles.reportingBottom}>
        <h5 className={styles.sponsoredGameTitle}>
          {gameName || t('game_info.missing_title_placeholder', 'Game title missing')}
        </h5>
        <div className={styles.reportingInfoArea}>
          <div className={styles.topPlayedInfoRow}>
            <Tooltip tooltipContent={t('game_info.players_count.tooltip', 'Number of players')}>
              {(tooltipProps) => (
                <div className={styles.gameInfo} {...tooltipProps}>
                  <span className={styles.topPlayedInfoIcon}>{getIcon('multipleUsers')}</span>
                  <span>{t('game_info.players_count', { count: playerInfo, defaultValue: '%{count} players' })}</span>
                </div>
              )}
            </Tooltip>
            <Tooltip tooltipContent={t('game_info.players_count.last_action', 'Date of last action')}>
              {(tooltipProps) => (
                <div className={styles.gameInfo} {...tooltipProps}>
                  <span className={styles.topPlayedInfoIcon}>{getIcon('recents')}</span>
                  <span>{new Date(modifiedAt + '').toLocaleDateString()}</span>
                </div>
              )}
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  )
}
